import { StepKeyName } from '../../types';

import styles from './Steps.scss';

export const TILE_BANNER_CLASSES_MAP: { [K in StepKeyName]: string } = {
  [StepKeyName.step1]: styles.bannerStep1,
  [StepKeyName.step2SNG]: styles.bannerStep2,
  [StepKeyName.step2Scheduled]: styles.bannerStep2,
  [StepKeyName.step3]: styles.bannerStep3,
  [StepKeyName.step4]: styles.bannerStep4
};
